import WithProposalContainer from '../Common/WithProposalContainer'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { PROPOSAL_TYPE_NAME } from '../../constants/proposalTypes'
import UpdateAttribute from '../../components/BatchProposal/UpdateAttribute'

UpdateAttribute.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const proposalType = PROPOSAL_TYPE.UPDATE_ATTRIBUTE

const props = {
  proposalType,
  proposalTypeName: PROPOSAL_TYPE_NAME[proposalType]
}

const MappedContainer = WithProposalContainer(UpdateAttribute, props)

export default MappedContainer
